/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    // document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");
    document.querySelector('#miniCartContentGift').classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }


    // UPSELL START HERE

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        const itemsToRemove = cart.items.filter(item => item.variant_id === cartSettings.protection_upsell.variants[0].id);
        if (itemsToRemove.length > 0) {
            for (let i = 0; i < itemsToRemove.length; i++) {
                cart = await changeProduct({
                    id: itemsToRemove[i].key,
                    quantity: 0,
                });
            }
            await openCart(true);
            return;
        }
    }

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderTitle").textContent = `Your Cart (${cart.item_count})`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // show main cart sections
    // document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Gift
    // 3 items required for gift
    if (cartSettings.enable_gift) {
        document.querySelector('#miniCartContentGift').classList.add("active");
        if (cart.item_count > 2) {
            // document.querySelector('#miniCartContentGiftBodyTitle').textContent = "";
            document.querySelector('#miniCartContentGiftBodyTxt').innerHTML = "Free Gift Reached!";
        } else {
            let until_reached = 3 - cart.item_count;
            // document.querySelector('#miniCartContentGiftBodyTitle').textContent = "Buy 2 Get 1 FREE";
            document.querySelector('#miniCartContentGiftBodyTxt').innerHTML = `Add <span>${until_reached} more</span> to get <span>1 FREE!</span>`;
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            // check for remote control
            if (item.variant_title.includes("true")) {
                let size = item.variant_title.split("/")[0];
                let remotePrice;

                // find the price of the remote
                if (productIdToMetafieldPrice[item.product_id]) {
                    remotePrice = productIdToMetafieldPrice[item.product_id];
                }
                let html = `<div class="miniCartBodyItemVariant">${size}</div>`;

                if (remotePrice > 0) {
                    html += `<div class="miniCartBodyItemVariant">+ Remote Control <span>${price(remotePrice)}</span></div>`;
                }

                return html;
            } else if (item.variant_title.includes("false")) {
                let size = item.variant_title.split("/")[0];
                return `<div class="miniCartBodyItemVariant">${size}</div>`;
            } else {
                return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
            }


        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<div>${price(item.final_line_price, false)} <s>${price(comparePrice, false)}</s></div>`
            } else {
                /****************** actual price ******************/
                HTML += `<div>${price(item.final_line_price, false)}</div>`;
            }

            /***************** savings *****************/
            // check for savings
            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    let saved = (savings / comparePrice) * 100;
                    HTML += `<span>${saved.toFixed(0)}% OFF</span>`;
                }
            }


            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {
            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-id="${item.variant_id}" 
                     data-plan="${sellingPlanID}"
                >
                    ${sellingPlanName}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                    </div>
                     <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">
                                <svg width="6" height="1" viewBox="0 0 6 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line y1="0.5" x2="6" y2="0.5" stroke="#2E3048"/>
                                </svg>

                            </button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.67578 4.58203V7.61035H3.93066V4.58203H0.90918V3.85742H3.93066V0.842773H4.67578V3.85742H7.68359V4.58203H4.67578Z" fill="#2E3048"/>
                                </svg>
                            </button>
                        </div>
                         <button class="miniCartBodyItemRemove">
                          REMOVE
                        </button>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const variantID = parseInt(this.dataset.id);
            const sellingPlanID = parseInt(this.dataset.plan);

            // add loading animation
            this.classList.add("loading");

            // remove this product from the cart
            await changeProduct({
                id: key,
                quantity: 0,
            });

            // add new product to cart (note, we don't change since we have a custom atc function)
            await addProduct({
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            });

            await openCart();

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellSwiperWrapItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);
        let index = Array.from(document.querySelectorAll(".miniCartUpsellSwiperWrapItem")).indexOf(element);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("visible");

        } else {
            element.classList.add("visible");
        }
        // update swiper because we just added or removed a slide manually
        upsellSwiper.update()
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellSwiperWrapItem.visible").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellSwitchInput")?.checked) {
        document.querySelector("#miniCartFooterPriceSubtotalPrice").textContent = price(cart.items_subtotal_price + cartSettings.protection_upsell.variants[0].price);
    } else {
        document.querySelector("#miniCartFooterPriceSubtotalPrice").textContent = price(cart.items_subtotal_price);
    }


    // if there are savings, show the savings section and update saved amount
    // check for savings
    let compare = null;
    cart.items.forEach(item => {
        // check if selling_plan_allocation exists, if so append compare_at_price * quantity
        if (item.selling_plan_allocation) {
            compare += item.selling_plan_allocation.compare_at_price * item.quantity;
        }
        // check for line item discount
        else if (item.original_line_price > item.final_line_price) {
            compare += item.original_line_price;
        }
        // check for compare at price
        else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
            compare += variantIDToCompareAtPrice[item.variant_id] * item.quantity;
        } else {
            // no compare at price, use final line price
            compare += item.final_line_price;
        }
    });
    document.querySelector("#miniCartFooterPriceSave").classList.remove("active");
    if (compare > cart.items_subtotal_price) {
        document.querySelector("#miniCartFooterPriceSave").classList.add("active");
        document.querySelector("#miniCartFooterPriceSavePrice").textContent = `-` + price(compare - cart.items_subtotal_price, true);
    }


}

// upsell swiper
let upsellSwiper = new Swiper('#miniCartUpsellSwiper', {
    slidesPerView: 1.5,
    spaceBetween: 10,
    pagination: {
        el: '#miniCartUpsellSwiperPag',
        clickable: true
    }
});

// Add Upsell function
document.querySelectorAll('.miniCartUpsellSwiperWrapItemBodyLink').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.dataset.product;

        // add loading animation
        this.classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});


// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellSwitchInput")?.checked) {
        console.log("yes!")
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));
